(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["badge-bestseller"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bsBadgeInit) return;
    window.__bsBadgeInit = true;

    function slidesOf(container) {
      return Array.prototype.filter.call(
        container.querySelectorAll('slideshow-slide'),
        function (s) { return s.querySelector('img'); }
      );
    }

    function distribute() {
      document.querySelectorAll('.product-bestseller-badge:not(.is-copy)').forEach(function (src) {
        var container = src.parentElement;
        if (!container || container.tagName.toLowerCase() !== 'slideshow-container') return;
        var slides = slidesOf(container);
        if (!slides.length) return;
        slides.forEach(function (slide) {
          if (slide.querySelector(':scope > .product-bestseller-badge')) return;
          var copy = src.cloneNode(true);
          copy.classList.remove('is-source');
          copy.classList.add('is-copy');
          slide.appendChild(copy);
        });
        src.classList.add('is-source');
      });
    }

    function place(badge) {
      var slide = badge.parentElement;
      var img = slide && slide.querySelector('img');
      if (!img || !img.naturalWidth || !img.naturalHeight) return;
      var sr = slide.getBoundingClientRect();
      var r = img.getBoundingClientRect();
      if (!sr.width || !r.width) return;
      var w = r.width, h = r.height;
      var fit = getComputedStyle(img).objectFit;
      if (fit === 'contain' || fit === 'scale-down') {
        var s = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
        if (fit === 'scale-down') s = Math.min(s, 1);
        w = img.naturalWidth * s;
        h = img.naturalHeight * s;
      }
      var off = window.innerWidth < 750 ? 10 : 14;
      var x = Math.max(0, r.left - sr.left + (r.width - w) / 2);
      var y = Math.max(0, r.top - sr.top + (r.height - h) / 2);
      badge.style.left = Math.round(x + off) + 'px';
      badge.style.top = Math.round(y + off) + 'px';
    }

    var timer = null;
    function update() {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        try {
          distribute();
          document.querySelectorAll('.product-bestseller-badge.is-copy').forEach(place);
        } catch (e) {}
      }, 30);
    }

    document.addEventListener('DOMContentLoaded', update);
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
    document.addEventListener('load', function (e) {
      if (e.target && e.target.tagName === 'IMG') update();
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t.closest && t.closest('slideshow-container')) { update(); return; }
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.matches('slideshow-container, slideshow-slide') || n.querySelector('slideshow-container'))) { update(); return; }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-swatches"] && !Shopify.designMode) return;
  try {
    if (!window.__cardSwatchesInit) {
    window.__cardSwatchesInit = true;
    const swap = (dot) => {
      const card = dot.closest('a');
      const img = card && card.querySelector('img');
      if (img && dot.dataset.csImg) {
        img.removeAttribute('srcset');
        img.src = dot.dataset.csImg;
      }
      if (card && dot.dataset.csUrl) card.setAttribute('href', dot.dataset.csUrl);
      const wrap = dot.closest('[data-cs]');
      if (wrap) wrap.querySelectorAll('.cs__dot.is-active').forEach((d) => d.classList.remove('is-active'));
      dot.classList.add('is-active');
    };
    document.addEventListener('click', (e) => {
      const dot = e.target.closest('.cs__dot');
      if (!dot) return;
      e.preventDefault();
      e.stopPropagation();
      swap(dot);
    }, true);
    document.addEventListener('keydown', (e) => {
      const dot = e.target.closest && e.target.closest('.cs__dot');
      if (!dot || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      swap(dot);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
